// Blog categories = matching problem tags + blog-only extras (video).
// Kept separate from PROBLEM_TAGS so therapist matching and homepage topic
// tiles never see non-therapy categories.
import { PROBLEM_TAGS, PROBLEM_TAG_LABELS } from "@/lib/matching/taxonomy";

export const BLOG_CATEGORIES = [...PROBLEM_TAGS, "video"] as const;
export type BlogCategory = (typeof BLOG_CATEGORIES)[number];

export const BLOG_CATEGORY_LABELS: Record<string, string> = {
  ...PROBLEM_TAG_LABELS,
  video: "Video sadržaj",
};

export function isBlogCategory(value: unknown): value is BlogCategory {
  return typeof value === "string" && (BLOG_CATEGORIES as readonly string[]).includes(value);
}
